import {Component, Input, OnInit} from '@angular/core';
import {Information} from "../information";

@Component({
  selector: 'app-information-linux',
  templateUrl: './information-linux.component.html',
  styleUrls: ['./information-linux.component.css']
})
export class InformationLinuxComponent  {
  @Input() information: Information;

  constructor() {
    this.information = new Information();
  }

}
